import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { activityRoutes } from './routes';
export class Activity {
  constructor() {
    _defineProperty(this, "routes", activityRoutes);
  }
  async getActivityLogs(data, options) {
    const resp = await requestService('activity').get(this.routes.activityLogs, _objectSpread(_objectSpread({}, options.cancelToken), {}, {
      params: _objectSpread({}, data)
    }));
    return resp.data;
  }
  async getActivityTypes(data, options) {
    const resp = await requestService('activity').get(this.routes.activityTypes, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getBatch(batchId, options) {
    const resp = await requestService('activity').get(this.routes.batch(batchId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}